/**
 * @generated SignedSource<<9e00e6f265a1fec8ec94798dd0ac3f03>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityActivitiesConnectionKind = "COMMENT" | "DATASET" | "SUBMISSION" | "TOPIC";
export type UserActivityCalendarFragmentQuery$variables = {
  date: string;
  first?: number | null | undefined;
  id: string;
  kinds?: ReadonlyArray<EntityActivitiesConnectionKind> | null | undefined;
};
export type UserActivityCalendarFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UserActivityCalendarFragment">;
  };
};
export type UserActivityCalendarFragmentQuery = {
  response: UserActivityCalendarFragmentQuery$data;
  variables: UserActivityCalendarFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": 366,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kinds"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "kinds",
  "variableName": "kinds"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserActivityCalendarFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserActivityCalendarFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserActivityCalendarFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "date"
                  },
                  (v5/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Activity",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "level",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "points",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "22bcb9ebcff9f66b716e78bfe4cd94b5",
    "id": null,
    "metadata": {},
    "name": "UserActivityCalendarFragmentQuery",
    "operationKind": "query",
    "text": "query UserActivityCalendarFragmentQuery(\n  $date: String!\n  $first: Int = 366\n  $kinds: [EntityActivitiesConnectionKind!]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UserActivityCalendarFragment_2ucDuh\n    id\n  }\n}\n\nfragment UserActivityCalendarFragment_2ucDuh on User {\n  activities(first: $first, after: $date, kinds: $kinds) {\n    edges {\n      node {\n        date\n        level\n        points\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "a390bb66c3123cba981bd131ac2b12aa";

export default node;
